export default __webpack_public_path__ + "static/media/photo--sm--143.97353381.jpg";